import React, {useEffect, useState} from "react"
import Styles from "./operate.less"
import {connect, useDispatch} from "react-redux"
import {NAVIGATIONINFO, VIEWTYPE} from "../util/utilData"
import {UseModel} from "../../function/hooks/useDataFromRedux"
import {OperateNavInfo, OperateProps} from "./interface"
import {HistoricalDataItem} from "../../reducer/interface/dataInterface"
import {UserPermissions} from "../../reducer/interface/userInterface"
import ShowMask from "../../function/hooks/showMask"
const Operate = (props: OperateProps) => {
    const dispatch = useDispatch()
    const model = UseModel()
    const showMask = ShowMask()
    const [selectItem, setSelectItem] = useState<number | string>(VIEWTYPE.CREATE)
    const [navigationInfo, setNavigationInfo] = useState(NAVIGATIONINFO)
    const [historySelect, setHistorySelect] = useState<HistoricalDataItem | null>(null)
    useEffect(() => {
        switch (props.global?.viewType) {
            case VIEWTYPE.TEST:
                setSelectItem(VIEWTYPE.TEST)
                break
            case VIEWTYPE.CREATE:
                setSelectItem(VIEWTYPE.CREATE)
                break
            case VIEWTYPE.HISTORY:
                setSelectItem(VIEWTYPE.HISTORY)
                model.invokeAsync("getHistoricalDataList", props.global?.billid)
                break
            case VIEWTYPE.SHOW:
                setSelectItem(VIEWTYPE.SHOW)
                break
            default:
                break
        }
        setNavigationInfo(
            navigationInfo.map((item) => {
                if (item.id === props.global?.viewType) {
                    return {
                        ...item,
                        selected: true,
                    }
                } else {
                    return {
                        ...item,
                        selected: false,
                    }
                }
            })
        )
    }, [props.global?.viewType])
    const handleSelect = (id: string | number) => {
        if (props.global?.viewType !== id) {
            dispatch({type: "setViewType", payload: id})
        }
    }
    const getHistoricalDetail = (id: string | number) => {
        dispatch({type: "saveQueryId", payload: id})
        dispatch({type: "activeView", payload: "display"})
        dispatch({type: "startLoading", payload: true})
        showMask.toTrue()
        dispatch({type: "setViewType", payload: VIEWTYPE.HISTORY})
        model.invokeAsync("getHistoricalDetailById", id)
    }
    const deleteHistoricalDetail = (id: string | number) => {
        dispatch({
            type: "showErrorLog",
            payload: {
                type: "cqErrorLog",
                data: {
                    title: "操作确认",
                    msg: "删除后将不能查看此条比对结果，是否确认删除",
                    onOk: () => {
                        dispatch({type: "setDeleteHistoricalDetailId", payload: id})
                        model.invokeAsync("deleteHistoricalDetailById", id)
                        dispatch({type: "hiddenErrorLog", payload: "hiddenErrorLog"})
                    },
                    onCancel: () => dispatch({type: "hiddenErrorLog", payload: "hiddenErrorLog"}),
                },
            },
        })
    } // TODO
    const selectHistory = (item: HistoricalDataItem) => {
        setHistorySelect(item)
    }
    const navInfoRenderData = {
        new: {},
        history: {
            selectItem: historySelect,
            dataSource: props.data && props.data.historicalDataList,
            handleSelect: selectHistory,
            getHistoricalDetail: getHistoricalDetail,
            deleteHistoricalDetail: deleteHistoricalDetail,
        },
    }
    const renderConsole = () => {
        const operatingConsole = (
            <div className={Styles.operatingConsole}>
                <div className={Styles.navigationBar}>
                    {navigationInfo.map((item) => {
                        if (item.isShow) {
                            return <NavItem key={item.id} onSelect={handleSelect} data={item} />
                        } else {
                            return null
                        }
                    })}{" "}
                </div>
                <div className={Styles.userInfo}>
                    <span>
                        视觉识别服务-流量版按原文档及比对文档总页数计次扣费，可进入视觉识别服务应用查看剩余次数。{" "}
                    </span>
                    {/* <UserPermission permissions={props.user?.permissions} /> */}
                </div>
            </div>
        )
        switch (props.global?.viewType) {
            case VIEWTYPE.TEST:
                return null
            case VIEWTYPE.SHOW:
                return null
            case VIEWTYPE.CREATE:
                return operatingConsole
            case VIEWTYPE.HISTORY:
                return operatingConsole
        }
    }
    return (
        <div className={Styles.operatingInterface}>
            {renderConsole()}
            <div className={Styles.operatingWindow}>
                {NAVIGATIONINFO[NAVIGATIONINFO.findIndex((item) => item.id === selectItem)].render(navInfoRenderData)}{" "}
            </div>
        </div>
    )
}
// 用户权限
const UserPermission: ({permissions}: {permissions: any}) => JSX.Element = ({permissions}) => {
    const getPermissionsPer = () => {
        return {
            width: `${(permissions.used / permissions.times) * 100}%`,
        }
    }
    return (
        <div className={Styles.userPermissions}>
            <div className={Styles.header}>比对次数</div>
            <div className={Styles.body}>
                <div className={Styles.permissionsPerOutBox}>
                    <div style={getPermissionsPer()} className={Styles.permissionsPerInnerBox} />
                </div>
                <span>已用{permissions.used}次</span>
                <span>剩余{permissions.times - permissions.used}次</span>
            </div>
            <div className={Styles.footer} />
        </div>
    )
}

const NavItem: ({onSelect, data}: {onSelect: (id: string) => void; data: OperateNavInfo}) => JSX.Element = ({
    onSelect,
    data,
}) => {
    const getStyle = () => {
        if (data.selected) {
            return {color: "#5582F3", backgroundColor: "#F2F6FF", borderRight: "3px solid #5582F3"}
        } else {
            return {color: "#212121"}
        }
    }
    return (
        <div onClick={() => onSelect(data.id)} style={getStyle()} className={Styles.navItemWrapper}>
            <img alt={""} src={data.selected ? data.activeImg : data.blurImg} />
            <span>{data.title}</span>
        </div>
    )
}

export default connect((state) => state)(Operate)
